import { render, staticRenderFns } from "./WidgetSettings.vue?vue&type=template&id=0f4c3001&scoped=true&"
import script from "./WidgetSettings.vue?vue&type=script&lang=ts&"
export * from "./WidgetSettings.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetSettings.vue?vue&type=style&index=0&id=0f4c3001&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c3001",
  null
  
)

export default component.exports